module.exports = __webpack_public_path__ + "media/placeholders/chart-28c7862d.png";